import { queryOptions } from "@tanstack/react-query";
import type { ApiClient } from "@/lib/api";
import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import type { UserSourceListEnvelope } from "../types";
import { userSourcesKeys } from "./query-keys";

const fetchUserSources = async ({
  client,
}: {
  client: ApiClient;
}): Promise<UserSourceListEnvelope> => {
  const { data } = await client.get<UserSourceListEnvelope>("/user_sources");
  return data;
};

export const userSourcesQueryOptions = ({
  scope,
}: {
  scope: OrgProjectScope;
}) => {
  const client = getCoordinatorApi(scope);

  return queryOptions<UserSourceListEnvelope>({
    queryKey: userSourcesKeys.list({ scope }),
    queryFn: () => fetchUserSources({ client }),
  });
};
